import * as _ from 'lodash';

import {ActionTypes} from "./purchaseActions";
import * as misc from "../../misc";

const subscriptionsExtraData = {
  'pay-per-lead': {
    'description': 'Get unlimited leads by signing up for our award winning Lead Program! ' +
      'Leads will be purchased for $35 a lead.',
    'title': 'Single Lead',
    className: 'pm-block--single-lead'
  },
  'basics': {
    'description': 'Upgrade to out  Basics Program and get all the excellent features of our lead program ' +
      'with with unlimited leads for only $299 per month.',
    'title': 'Basics Lead Program',
    className: 'pm-block--lead-program'
  },
  'enterprise': {
    'description': 'Our Enterprise Program is the ultimate package with unlimited leads, complete Enterprise ' +
      'Quoting Tool and the Quote Countertops Off-Line application.',
    'title': 'Enterprise Lead Program',
    className: 'pm-block--purchase-enterprise'
  }
}

const subscriptionSortOrder = {
  'pay-per-lead': 1,
  'basics': 2,
  'enterprise': 3
}

export const subscriptionPeriodMapper = period => {
  switch (period) {
    case 'monthly': return 'Month';
    case 'annually': return "Year";
    default: return period;
  }
}

// http://unicode.org/cldr/trac/browser/tags/release-26-0-1/common/supplemental/postalCodeData.xml
export const supportedCountries = [{
  name: 'USA',
  zipCodeRg: /^\d{5}([ \-]\d{4})?$/
}, {
  name: 'Canada',
  zipCodeRg: /^[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d$/
}, {
  name: 'UK',
  zipCodeRg: /^GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}$/
}];

let __subType = null;
(function(){
  const params = misc.parseQuery();
  __subType = params['sub_type'];
})();

const initialState = {
  isModal: false, // if true the [close modal] button will be visible
  step: 1,
  subscriptionsGroups: [],
  selectedSubscriptionGroup: '',
  selectedSubscription: null,
  selectedSubscriptionGroupRef: null,
  isBusy: false,
  busyText: 'Loading data...',
  isPayPalSupported: false,
  isCreditCardSupported: true,
  isBitCoinSupported: false,
  paymentInfo: {
    name: '',
    country: _.find(supportedCountries, {name: 'USA'}),
    zipCode: '',
    ccNum: '',
    expMonth: '',
    expYear: '',
    cvv: ''
  }
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SELECT_SUBSCRIPTION_GROUP:
      return selectSubscriptionGroup(state, action.payload);
    case ActionTypes.NEXT_STEP:
      const {step} = action.payload;
      return {...state, step};
    case ActionTypes.LOAD_SUBSCRIPTIONS_REQUEST:
      return {...state, isBusy: true};
    case ActionTypes.LOAD_SUBSCRIPTIONS_RESPONSE:
      return setSubscriptions(state, action.payload);
    case ActionTypes.UPDATE_PAYMENT_INFO:
      const {paymentInfo} = action.payload;
      return {...state, paymentInfo: _.cloneDeep(paymentInfo)};
    case ActionTypes.SUBMIT_PAYMENT_REQUEST:
      return {...state, isBusy: true};
    case ActionTypes.SUBMIT_PAYMENT_RESPONSE:
      return {...state, isBusy: false};
    case ActionTypes.GOTO_STEP: {
      const {step} = action.payload;
      return {...state, step};
    }
    case ActionTypes.SELECT_SUBSCRIPTION:
      return selectSubscription(state, action.payload);
    default:
      return state;
  }
}

function selectSubscriptionGroup(state, {subscriptionGroup}) {
  const subscriptionGroupRef = _.find(state.subscriptionsGroups, {groupName: subscriptionGroup});
  return {...state,
    selectedSubscriptionGroup: subscriptionGroup,
    selectedSubscriptionGroupRef: subscriptionGroupRef,
    selectedSubscription: subscriptionGroupRef.selectedSubscription
  };
}

function selectSubscription(state, {groupName, subscription}) {
  const subscriptionGroup = _.find(state.subscriptionsGroups, {groupName});
  const selectedSubscription = _.find(subscriptionGroup.subscriptions, {id: subscription.id});
  let changeGroup = selectedSubscription.id !== subscriptionGroup.selectedSubscription.id;
  subscriptionGroup.selectedSubscription = selectedSubscription;
  if (changeGroup) {
    state.selectedSubscriptionGroup = groupName;
  }

  return {...state,
    subscriptionsGroups: state.subscriptionsGroups,
    selectedSubscriptionGroup: state.selectedSubscriptionGroup,
    selectedSubscriptionGroupRef: subscriptionGroup,
    selectedSubscription: subscriptionGroup.selectedSubscription
  };
}

function setSubscriptions(state, {subs}) {
  const subscriptionsGroups = [];
  const groups = _.groupBy(subs, s => s.type);
  const groupNames = _.orderBy(_.keys(groups), key => subscriptionSortOrder[key]);

  _.forEach(groupNames, groupName => {
    const exData = subscriptionsExtraData[groupName];
    const subscriptions = groups[groupName];

    subscriptionsGroups.push({
      ...exData,
      groupName,
      selectedSubscription: _.first(subscriptions),
      subscriptions: subscriptions || []
    })
  });

  let selectedSubscriptionGroup = _.first(groupNames);
  if (__subType) {
    if (__subType === 'lead_only') {
      selectedSubscriptionGroup = 'pay-per-lead';
    } else if (__subType === 'unlimited_leads') {
      selectedSubscriptionGroup = 'basics';
    }
  }

  const selectedSubscriptionGroupRef = _.find(subscriptionsGroups, {groupName: selectedSubscriptionGroup});
  return {...state,
    isBusy: false,
    subscriptionsGroups,
    selectedSubscriptionGroup,
    selectedSubscriptionGroupRef,
    selectedSubscription: selectedSubscriptionGroupRef.selectedSubscription
  }
}


